import { createCRUDService } from '@/services/genericCRUD';
import { benchmarkEntity } from '@/config/entities/benchmarks';

export const benchmarkService = createCRUDService(benchmarkEntity);
